// extracted by css-extract-rspack-plugin
export default {"root":"B9O9Jt","thumb":"heExw6","details":"HK7vX1","title":"dUZ55O","no-preview":"aIePbn","noPreview":"aIePbn","extension":"xdA4Np"};